import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import config from "../../config";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchNews } from "../../redux/slice/news";
import placeImage from "../../images/placeholder.jpg";
import Dataloader from "../../Component/Dataloader";
import NoData from "../../Component/NoData";

export default function NewsDetail() {
  const params = useParams();
  const [newsDetail, setNewsDetail] = useState([]);
  const [exist, setExist] = useState(true);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchNewsDetail = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${config.apiUrl}/view-market-news/${params.slug}`
        );
        setNewsDetail(response.data.market_news);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setExist(false);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchNewsDetail();
  }, [params.slug]);

  const dispatch = useDispatch();
  const { newsData, isError } = useSelector((state) => state.news);
  useEffect(() => {
    if (!isError) {
      dispatch(fetchNews());
    }
  }, [dispatch, isError]);

  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="showcase-product mrb1">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : exist ? (
              <div className="row">
                <div className="col-lg-8">
                  <article className="entry">
                    <figure className="entry-media">
                      <img
                        src={newsDetail.image}
                        onError={imageOnError}
                        alt="news"
                      />
                    </figure>

                    <div className="entry-body">
                      <div className="entry-meta">
                        <span className="entry-author">
                          <p>By Biznie</p>
                        </span>
                        <span className="meta-separator">|</span>
                        <p>{newsDetail.created_at}</p>
                      </div>
                      <h2 className="entry-title">{newsDetail.title}</h2>
                      <div className="entry-content">
                        <p>{newsDetail.description}</p>
                      </div>

                      <div className="entry-footer row no-gutters flex-column flex-md-row">
                        <div className="col-md-auto mt-2 mt-md-0">
                          <div className="social-icons social-icons-color">
                            <span className="social-label">
                              Share this post:
                            </span>
                            <a
                              href="https://www.facebook.com/"
                              className="social-icon social-facebook"
                              title="Facebook"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="bi bi-facebook"></i>
                            </a>
                            <a
                              href="https://x.com/?lang=en"
                              className="social-icon social-twitter"
                              title="X"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="bi bi-twitter-x"></i>
                            </a>
                            <a
                              href="https://www.instagram.com/"
                              className="social-icon social-instagram"
                              title="instagram"
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="bi bi-instagram"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
                <aside className="col-lg-4">
                  <div className="sidebar">
                    <div className="widget">
                      <h3 className="widget-title">Related News</h3>
                      <ul className="posts-list">
                        {newsData.slice(0, 4).map((news, index) => (
                          <li key={index}>
                            <Link to={`/news-detail/${news.slug}`}>
                              <figure>
                                <img
                                  src={news.image}
                                  onError={imageOnError}
                                  alt="post"
                                />
                              </figure>
                              <div>
                                <span>{news.created_at}</span>
                                <h4 className="two-line-clamp">{news.title}</h4>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </aside>
              </div>
            ) : (
              <div className="row">
                <div className="col-lg-12">
                  <NoData />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
